import { Grid } from "@mui/material";

function Home() {
    return (
        <>
            <div className="app-page-home">
                <Grid container spacing={2}>
                    <Grid item lg="7">
                        <div className="app-page-home__reportcards">
                          
                        </div>
                        {/* <div className="app-page-home__announcements mt-30">
                            <Annoncement />
                        </div> */}
                    </Grid>
                    <Grid item lg="5">
                        <div className="app-page-home__feeds">
                    
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default Home;